import { ReactNode, useEffect, useState } from 'react';

type Step = { title: string; body: ReactNode };

export default function OnboardingModal({ open, onClose, steps, title = 'Getting Started' }: { open: boolean; onClose: () => void; steps: Step[]; title?: string }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => { if (!open) setIdx(0); }, [open]);
  if (!open) return null;
  const step = steps[Math.max(0, Math.min(steps.length - 1, idx))];
  const canPrev = idx > 0;
  const canNext = idx < steps.length - 1;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 100,
      }}
      onClick={onClose}
    >
      <div className="card" style={{ width: '92vw', maxWidth: 820, padding: 16 }} onClick={(e) => e.stopPropagation()}>
        <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <div className="row" style={{ gap: 6 }}>
            <button className="btn secondary" disabled={!canPrev} onClick={() => setIdx(i => Math.max(0, i - 1))}>Prev</button>
            <button className="btn secondary" disabled={!canNext} onClick={() => setIdx(i => Math.min(steps.length - 1, i + 1))}>Next</button>
            <button className="btn neutral" onClick={onClose}>Close</button>
          </div>
        </div>
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>{step?.title}</div>
          <div className="muted" style={{ lineHeight: 1.6 }}>{step?.body}</div>
        </div>
        <div className="row" style={{ gap: 4, marginTop: 8, justifyContent: 'center' }}>
          {steps.map((_, i) => (
            <span key={i} style={{ width: 8, height: 8, borderRadius: 9999, background: i === idx ? '#3b82f6' : 'rgba(255,255,255,0.25)' }} />
          ))}
        </div>
      </div>
    </div>
  );
}
